var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer-page"},[_c('x-table',{attrs:{"no-data-text":_vm.CA('log_check') ? '暂无数据' : '暂无数据查询权限',"columns":_vm.table.columns,"data":_vm.table.data,"loading":_vm.table.loading,"config":_vm.config},on:{"search":_vm.search,"page-change":_vm.pageChange,"page-size-change":_vm.pageSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }